// src/components/AppComponents/Sidebar/Sidebar.tsx

import { RiExpandLeftLine, RiExpandRightLine } from '@remixicon/react';

import i18n from '@/shared/i18n/i18n';
// import { useBreakpoint } from '@/shared/hooks/useTailwindBreakpoint';
import { cx } from '@UI/lib/utils';
import { useUserSettingsStore } from '@/domains/user/userSettings.store';

// import ConfigNav from './ConfigNav';
import { Button } from '@UI/components/Button';

import RevHubImago from '@/assets/images/RevHubImago';
import CustomerMenu from './CustomerMenu';
import { useUserCustomersStore } from '@/domains/user/userCustomers.store';
import NavBar from './NavBar';
import RevHubLogo from '@/assets/images/RevHubLogo';
import NoNavBar from '@/views/Guest/NavBar';
import UserProfile from './UserProfile';

const Sidebar: React.FC = () => {
  const selectedCustomer = useUserCustomersStore((s) => s.selectedCustomer);
  const isCollapsed = useUserSettingsStore(
    (state) => state.settings.menu_collapsed,
  );
  const toggleMenu = useUserSettingsStore((state) => state.toggleMenuCollapsed);
  // const isLgUp = useBreakpoint('lg');
  return (
    <aside
      className={cx(
        'fixed z-50 flex border-solid px-4 transition-all bg-revving-background', // generic styles
        'max-lg:w-full max-lg:sticky max-lg:z-[999] top-0 h-14 flex-row max-lg:gap-2 justify-between items-center', // mobile & tablet styles
        `${isCollapsed ? 'lg:w-[var(--collapsed-sidebar-width)]' : 'lg:w-[var(--expanded-sidebar-width)] lg:overflow-hidden'}`, // collapsed/expanded styles
        `lg:h-full lg:flex-col lg:justify-start lg:items-${isCollapsed ? 'center' : 'stretch'} lg:p-0`, // desktop styles
        'dark:bg-darkRevving-background', // dark mode styles
      )}
    >
      {/* Logo Section :: BEGINS */}
      <div
        className={cx(
          'order-3  flex top-0 flex-1 justify-center items-center py-2 lg:py-0 lg:px-4',
          'lg:order-1 lg:flex-none lg:border-b lg:sticky lg:z-50 lg:h-24 lg:w-full',
          'bg-white dark:bg-darkRevving-background dark:border-darkRevving-border',
        )}
      >
        {isCollapsed ? (
          <RevHubImago className="w-full h-8 lg:h-16" />
        ) : (
          <RevHubLogo className="w-full h-8 lg:h-16" />
        )}
      </div>
      {/* Logo Section :: ENDS */}
      <div className="hidden lg:block order-2 py-4 px-8 border-b w-full justify-center dark:border-darkRevving-border">
        <Button
          onClick={toggleMenu}
          icon={isCollapsed ? RiExpandRightLine : RiExpandLeftLine}
          variant="ghost"
          className={`menuButton justify-center ${isCollapsed ? 'collapsed' : ''}`}
        >
          {isCollapsed || i18n.t('navBar.collapse')}
        </Button>
      </div>

      <div className="order-2 lg:order-3 flex-none lg:pt-6 lg:pb-4 lg:px-2">
        <CustomerMenu />
      </div>

      <div
        className={`order-4 lg:h-full ${isCollapsed ? '' : 'overflow-y-auto'}`}
      >
        {selectedCustomer ? (
          <NavBar
            isCollapsed={isCollapsed}
            customerType={selectedCustomer.type}
          />
        ) : (
          <NoNavBar />
        )}
      </div>

      <div className="order-1 lg:order-5 flex-none lg:pt-4 lg:pb-2 lg:px-2">
        <UserProfile />
      </div>
    </aside>
  );
};
export default Sidebar;
